
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("eoBBJ", function(module, exports) {

$parcel$export(module.exports, "EditionAwarenessContext", () => $e386a7914d299870$export$ac3ca8c46f19a73f);
$parcel$export(module.exports, "useEditionAwareness", () => $e386a7914d299870$export$5a5baedfe8151ce);

var $gwFzn = parcelRequire("gwFzn");
const $e386a7914d299870$export$ac3ca8c46f19a73f = /*#__PURE__*/ (0, $gwFzn.createContext)(null);
function $e386a7914d299870$export$5a5baedfe8151ce() {
    const context = (0, $gwFzn.useContext)($e386a7914d299870$export$ac3ca8c46f19a73f);
    if (!context) throw new Error('Missing context, please ensure this is used within EditionAwarenessContext');
    return context;
}

});

parcelRegister("ecqMk", function(module, exports) {

$parcel$export(module.exports, "getHamsKey", () => $0a0029952ec94989$export$291d012eb0744b34);
const $0a0029952ec94989$var$ProductKeyToHAMSMap = {
    ['confluence']: 'confluence',
    ['jira']: 'jira-software',
    ['jira-product-discovery']: 'jira-product-discovery',
    ['jira-service-management']: 'jira-servicedesk'
};
const $0a0029952ec94989$export$291d012eb0744b34 = (product)=>{
    return $0a0029952ec94989$var$ProductKeyToHAMSMap[product];
};

});

parcelRegister("b8Yvt", function(module, exports) {

$parcel$export(module.exports, "useConfig", () => $d5b5285bd1f76545$export$b3611e87cd5ba6ce);

var $gwFzn = parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
function $d5b5285bd1f76545$export$b3611e87cd5ba6ce(product, edition) {
    return (0, $gwFzn.useMemo)(()=>{
        if (product === 'jira-product-discovery') {
            if (edition === 'free') return {
                shouldSkip: (0, $dh538.fg)('jpd_disable_edition_awareness'),
                warnOnUserLimit: true,
                shouldCheckBillingAdmin: false
            };
            else if (edition === 'standard' || edition === 'premium') return {
                shouldSkip: (0, $dh538.fg)('jpd_disable_edition_awareness')
            };
        }
        if (product === 'jira') {
            if (edition === 'free') return {
                shouldCheckBillingAdmin: false,
                warnOnUserLimit: true,
                shouldCheckForTwc: (0, $dh538.fg)('teamwork_collection_ea_modal')
            };
            if (edition === 'standard') return {
                isStandardTrialsUserAndStorageLimitBreakersEnabled: (0, $dh538.fg)('jira_edition_awareness_standard_trials_gate'),
                isPaidStandard: (0, $dh538.fg)('edition_awareness_upsell_jira_fg'),
                shouldCheckForTwc: (0, $dh538.fg)('teamwork_collection_ea_modal')
            };
            if (edition === 'premium') return {
                shouldCheckForTwc: (0, $dh538.fg)('teamwork_collection_ea_modal')
            };
        }
        if (product === 'jira-service-management') {
            if (edition === 'free') return {
                shouldCheckBillingAdmin: false,
                warnOnUserLimit: true
            };
            if (edition === 'standard') return {
                isPaidStandard: (0, $dh538.fg)('edition_awareness_upsell_jsm_fg')
            };
        }
        if (product === 'confluence') {
            if (edition === 'free') return {
                shouldCheckBillingAdmin: false,
                shouldCheckForTwc: (0, $dh538.fg)('teamwork_collection_ea_modal')
            };
            if (edition === 'standard') return {
                isStandardTrialsUserAndStorageLimitBreakersEnabled: (0, $dh538.fg)('connie_edition_awareness_standard_trials_gate'),
                isPaidStandard: (0, $dh538.fg)('edition_awareness_standard_upsell_confluence_ab_fg'),
                shouldCheckForTwc: (0, $dh538.fg)('teamwork_collection_ea_modal')
            };
            if (edition === 'premium') return {
                shouldCheckForTwc: (0, $dh538.fg)('teamwork_collection_ea_modal'),
                shouldCheckReverseTrial: (0, $dh538.fg)('new_ea_confluence_reverse_trial')
            };
        }
        // Default return for other products and editions
        return {};
    }, [
        product,
        edition
    ]);
}

});

parcelRegister("iW8ja", function(module, exports) {

$parcel$export(module.exports, "useSpotlight", () => $b45d16ed15e9cbf0$export$cc7026713a353975);

var $gwFzn = parcelRequire("gwFzn");
function $b45d16ed15e9cbf0$export$cc7026713a353975() {
    const [isSpotlightActive, setIsSpotlightActive] = (0, $gwFzn.useState)(false);
    const handleSetSpotlight = (0, $gwFzn.useCallback)((isActive)=>{
        setIsSpotlightActive(isActive);
    }, [
        setIsSpotlightActive
    ]);
    return {
        isSpotlightActive: isSpotlightActive,
        handleSetSpotlight: handleSetSpotlight
    };
}

});

parcelRegister("ac7kz", function(module, exports) {

$parcel$export(module.exports, "ANALYTICS_CHANNEL", () => $2a8aa1aaafc441a7$export$85183a312807388d);
$parcel$export(module.exports, "getAttributesFromContexts", () => $2a8aa1aaafc441a7$export$d97c97ed77ff09e8);
$parcel$export(module.exports, "defaultAttributes", () => $2a8aa1aaafc441a7$export$38cd8db2db178f58);
$parcel$export(module.exports, "useAnalytics", () => $2a8aa1aaafc441a7$export$e955abb82869dc84);

var $gwFzn = parcelRequire("gwFzn");

var $3pfAb = parcelRequire("3pfAb");

var $6v6KC = parcelRequire("6v6KC");
var $inPa6 = parcelRequire("inPa6");

var $c6GJD = parcelRequire("c6GJD");

var $eoBBJ = parcelRequire("eoBBJ");
const $2a8aa1aaafc441a7$export$85183a312807388d = (0, $3pfAb.FabricChannel).growth;
const $2a8aa1aaafc441a7$export$d97c97ed77ff09e8 = (context)=>{
    if (!context || !Array.isArray(context)) return {};
    return context.reduce((acc, x)=>{
        if (x.attributes) return {
            ...acc,
            ...x.attributes
        };
        return {
            ...acc,
            ...x ?? {}
        };
    }, {});
};
const $2a8aa1aaafc441a7$export$38cd8db2db178f58 = {
    packageName: '@atlassian/edition-awareness',
    source: 'editionAwareness',
    featureId: 'edition-awareness',
    growthPillar: 'BUY'
};
function $2a8aa1aaafc441a7$export$e955abb82869dc84() {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const editionAwarenessContext = (0, $eoBBJ.useEditionAwareness)();
    const experimentMeta = (0, $gwFzn.useMemo)(()=>{
        // I wanted to reference the utility function but,
        // that file imports AtlBrowserStorageLocal which makes the VR tests to fail with timeout, even if is not executed on runtime
        //if (isFreeEduOrOrgSite(editionAwarenessContext)) {
        //Only add the metadata when the site may be eligible for the experiment
        if (editionAwarenessContext.edition === 'free' && (editionAwarenessContext.siteType === 'EDU' || editionAwarenessContext.siteType === 'ORG')) return [
            {
                key: 'offer_edu_org_discount',
                cohort: (0, $c6GJD.default).getExperimentValue('offer_edu_org_discount', 'cohort', 'not-enrolled'),
                siteType: editionAwarenessContext.siteType
            }
        ];
        return [];
    }, [
        editionAwarenessContext
    ]);
    const sendAnalyticsEvent = (0, $gwFzn.useCallback)((payload)=>{
        const editionAwarenessContextAttributes = {
            // Required properties
            cloudId: editionAwarenessContext.cloudId,
            product: editionAwarenessContext.product,
            currentProductEdition: editionAwarenessContext.edition,
            config: editionAwarenessContext.config,
            // Payment properties
            isInvoiceable: editionAwarenessContext.isInvoiceable,
            canAddPaymentDetails: editionAwarenessContext.canAddPaymentDetails,
            addPaymentDetailsExperienceUrl: editionAwarenessContext.addPaymentDetailsExperienceUrl,
            // Trial properties
            trialDaysLeft: editionAwarenessContext.trialDaysLeft,
            trialLengthDays: editionAwarenessContext.trialLengthDays,
            trialEndDate: editionAwarenessContext.trialEndDate,
            isInTrial: editionAwarenessContext.isInTrial,
            isInPredunning: editionAwarenessContext.isInPredunning,
            isInReverseTrial: editionAwarenessContext.isInReverseTrial,
            trialOfferingName: editionAwarenessContext.trialOfferingName,
            changeOfferingToStandardExperienceUrl: editionAwarenessContext.changeOfferingToStandardExperienceUrl,
            // Entitlement properties
            isInTeamWorkCollection: editionAwarenessContext.isInTeamWorkCollection,
            // User permissions properties
            canUpgrade: editionAwarenessContext.canUpgrade,
            userRoles: editionAwarenessContext.userRoles,
            userEmail: editionAwarenessContext.userEmail,
            // Site properties
            siteType: editionAwarenessContext.siteType,
            billingSourceSystem: editionAwarenessContext.billingSourceSystem,
            licensedUsers: editionAwarenessContext.licensedUsers,
            storageUsageInGB: editionAwarenessContext.storageUsageInGB,
            // Capabilities
            hasDismissedButton: editionAwarenessContext.hasDismissedButton,
            isSpotlightActive: editionAwarenessContext.isSpotlightActive,
            shouldAutoOpen: editionAwarenessContext.shouldAutoOpen
        };
        if (payload instanceof (0, $6v6KC.default)) {
            const contextAttributes = $2a8aa1aaafc441a7$export$d97c97ed77ff09e8(payload.context);
            payload.update({
                ...payload.payload,
                attributes: {
                    ...contextAttributes,
                    ...$2a8aa1aaafc441a7$export$38cd8db2db178f58,
                    ...payload.payload.attributes,
                    ...editionAwarenessContextAttributes,
                    experimentMeta: experimentMeta
                }
            }).fire($2a8aa1aaafc441a7$export$85183a312807388d);
        } else {
            const event = createAnalyticsEvent({
                ...payload,
                attributes: {
                    ...$2a8aa1aaafc441a7$export$38cd8db2db178f58,
                    ...payload.attributes,
                    ...editionAwarenessContextAttributes,
                    experimentMeta: experimentMeta
                }
            });
            const contextAttributes = $2a8aa1aaafc441a7$export$d97c97ed77ff09e8(event.context);
            event.update({
                attributes: {
                    ...contextAttributes,
                    ...event.payload.attributes
                }
            }).fire($2a8aa1aaafc441a7$export$85183a312807388d);
        }
    }, [
        createAnalyticsEvent,
        editionAwarenessContext,
        experimentMeta
    ]);
    return {
        sendAnalyticsEvent: sendAnalyticsEvent
    };
}
function $2a8aa1aaafc441a7$export$b901544a79a3bbad({ name: name, attributes: attributes }) {
    const { sendAnalyticsEvent: sendAnalyticsEvent } = $2a8aa1aaafc441a7$export$e955abb82869dc84();
    const hasSent = (0, $gwFzn.useRef)(false);
    (0, $gwFzn.useEffect)(()=>{
        if (hasSent.current) return;
        sendAnalyticsEvent({
            eventType: 'screen',
            name: name,
            attributes: attributes
        });
        hasSent.current = true;
    }, [
        sendAnalyticsEvent,
        name,
        attributes
    ]);
    return null;
}

});

parcelRegister("8pzEG", function(module, exports) {

$parcel$export(module.exports, "FeatureExposedAnalytics", () => $12c853e475c615c0$export$b12ce465f015026c);
$parcel$export(module.exports, "useFeatureExposedAnalytics", () => $12c853e475c615c0$export$5218ddb3d9c658c0);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $ac7kz = parcelRequire("ac7kz");
function $12c853e475c615c0$export$b12ce465f015026c({ flagKey: flagKey, cohort: cohort, growthInitiative: growthInitiative, attributes: attributes, children: children }) {
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $ac7kz.useAnalytics)();
    const hasSent = (0, $gwFzn.useRef)(false);
    (0, $gwFzn.useEffect)(()=>{
        if (hasSent.current) return;
        sendAnalyticsEvent({
            eventType: 'track',
            action: 'exposed',
            actionSubject: 'feature',
            attributes: {
                ...attributes,
                flagKey: flagKey,
                cohort: cohort,
                growthInitiative: growthInitiative
            }
        });
        hasSent.current = true;
    }, [
        sendAnalyticsEvent,
        flagKey,
        cohort,
        growthInitiative,
        attributes
    ]);
    if (!children) return null;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {
        children: children
    });
}
const $12c853e475c615c0$export$5218ddb3d9c658c0 = ()=>{
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $ac7kz.useAnalytics)();
    const sentFlagKeys = (0, $gwFzn.useRef)([]);
    const fireExperimentExposureEvent = (0, $gwFzn.useCallback)((flagKey, cohort, growthInitiative, attributes)=>{
        if (sentFlagKeys.current.includes(flagKey)) return;
        sendAnalyticsEvent({
            eventType: 'track',
            action: 'exposed',
            actionSubject: 'feature',
            attributes: {
                ...attributes,
                flagKey: flagKey,
                cohort: cohort,
                growthInitiative: growthInitiative
            }
        });
        sentFlagKeys.current.push(flagKey);
    }, [
        sendAnalyticsEvent
    ]);
    return fireExperimentExposureEvent;
};

});

parcelRegister("fTb0L", function(module, exports) {

$parcel$export(module.exports, "isEligibleForConfluenceBuyReverseTrialExperiment", () => $e43506c97bd21691$export$d8e323470f628b52);
function $e43506c97bd21691$export$d8e323470f628b52({ context: context }) {
    const { product: product, edition: edition, isInvoiceable: isInvoiceable, isInReverseTrial: isInReverseTrial, isInTrial: isInTrial, isInPredunning: isInPredunning, billingSourceSystem: billingSourceSystem } = context;
    return Boolean(product === 'confluence' && edition === 'premium' && (isInTrial || isInPredunning) && isInReverseTrial && isInvoiceable === false && billingSourceSystem === 'CCP');
}

});

parcelRegister("kzWPO", function(module, exports) {

$parcel$export(module.exports, "isEligibleForEduDiscount", () => $ca6ff173d640ef42$export$331edc99898f4a8e);
//import { AtlBrowserStorageLocal } from '@atlassian/browser-storage-controls';

var $3Ld4I = parcelRequire("3Ld4I");
const $ca6ff173d640ef42$export$331edc99898f4a8e = (context)=>{
    return $ca6ff173d640ef42$export$f52e80ca0459b360(context) && $ca6ff173d640ef42$export$eb0afc9e31269a96();
};
const $ca6ff173d640ef42$export$f52e80ca0459b360 = (context)=>{
    const { edition: edition, siteType: siteType } = context;
    return edition === 'free' && (siteType === 'EDU' || siteType === 'ORG');
};
const $ca6ff173d640ef42$export$eb0afc9e31269a96 = ()=>{
    // AtlBrowserStorageLocal even if is not executed, by just calling this file fails the VR test,
    //  until we have a fix, we can use the native one
    //AtlBrowserStorageLocal.getItem(PLATFORM_EDUCATIONAL_DISCOUNT_DISMISSED) !== 'true'
    try {
        return localStorage.getItem((0, $3Ld4I.PLATFORM_EDUCATIONAL_DISCOUNT_DISMISSED)) !== 'true';
    } catch (e) {
        return false;
    }
};

});
parcelRegister("3Ld4I", function(module, exports) {

$parcel$export(module.exports, "PLATFORM_EDUCATIONAL_DISCOUNT_DISMISSED", () => $658076bfad0c6daf$export$c5bc624b59af1952);
const $658076bfad0c6daf$export$c5bc624b59af1952 = '__storejs_platform_educational_discount_dismissed';

});


parcelRegister("6T6L4", function(module, exports) {

$parcel$export(module.exports, "isEligibleForStandardTrialsUserAndStorageLimitBreakers", () => $f7f27f2cb492c502$export$4ade6028e006f174);
function $f7f27f2cb492c502$export$4ade6028e006f174({ context: context }) {
    const { config: { isStandardTrialsUserAndStorageLimitBreakersEnabled: isStandardTrialsUserAndStorageLimitBreakersEnabled }, product: product, isInTrial: isInTrial, isInPredunning: isInPredunning, isInvoiceable: isInvoiceable, licensedUsers: licensedUsers, canAddPaymentDetails: canAddPaymentDetails, trialDaysLeft: trialDaysLeft, storageUsageInGB: storageUsageInGB } = context;
    const isOnFirstTrialDay = !!(trialDaysLeft && trialDaysLeft === 14);
    const isOverUserLimit = !!(licensedUsers && licensedUsers > 10);
    const isOverStorageUsageLimit = !!(storageUsageInGB && storageUsageInGB > 2);
    if (product === 'confluence') return !!(isStandardTrialsUserAndStorageLimitBreakersEnabled && (isInTrial || isInPredunning) && isInvoiceable === false && canAddPaymentDetails && !isOnFirstTrialDay && (isOverUserLimit || isOverStorageUsageLimit));
    if (product === 'jira') return !!(isStandardTrialsUserAndStorageLimitBreakersEnabled && isInTrial && isInvoiceable === false && canAddPaymentDetails && !isOnFirstTrialDay && (isOverUserLimit || isOverStorageUsageLimit));
    return false;
}

});

parcelRegister("cg1pB", function(module, exports) {

$parcel$export(module.exports, "useOnDismissDialog", () => $39cdbde26d9c73b9$export$566c270c8354ea95);

var $gwFzn = parcelRequire("gwFzn");

var $ac7kz = parcelRequire("ac7kz");
const $39cdbde26d9c73b9$export$566c270c8354ea95 = ({ touchpointIntent: touchpointIntent, dialogType: dialogType, dialogId: dialogId, attributes: attributes, onClose: onClose })=>{
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $ac7kz.useAnalytics)();
    return (0, $gwFzn.useCallback)(()=>{
        sendAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'editionAwarenessDialogDismissed',
            attributes: {
                touchpointIntent: touchpointIntent,
                dialogType: dialogType,
                dialogId: dialogId,
                ...attributes
            }
        });
        onClose && onClose();
    }, [
        sendAnalyticsEvent,
        touchpointIntent,
        dialogType,
        dialogId,
        attributes,
        onClose
    ]);
};

});

parcelRegister("fVYKU", function(module, exports) {

$parcel$export(module.exports, "ModalEntryPoint", () => $3419347acdf26ff2$export$50a5ec7edfae079b);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $bYRk6 = parcelRequire("bYRk6");

var $fAD9L = parcelRequire("fAD9L");

var $7wGk4 = parcelRequire("7wGk4");

var $70Blk = parcelRequire("70Blk");

var $aKQ5r = parcelRequire("aKQ5r");
function $3419347acdf26ff2$export$50a5ec7edfae079b(props) {
    const { dialogConfig: dialogConfig, ...rest } = props;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $bYRk6.default), {
        data: dialogConfig,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)($3419347acdf26ff2$var$ModalEntryPointInner, {
            ...rest
        })
    });
}
function $3419347acdf26ff2$var$ModalEntryPointInner(props) {
    const onError = (0, $70Blk.useEntrypointErrorAnalytics)();
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fAD9L.ModalContextProvider), {
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7wGk4.ModalTrigger), {
            ...props,
            onError: onError,
            children: ({ ref: ref })=>{
                return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aKQ5r.EditionAwarenessButton), {
                    ref: ref
                });
            }
        })
    });
}

});
parcelRegister("70Blk", function(module, exports) {

$parcel$export(module.exports, "useEntrypointErrorAnalytics", () => $e3ebf0d7bad26c5e$export$f2e26e89f653216c);

var $gwFzn = parcelRequire("gwFzn");

var $ac7kz = parcelRequire("ac7kz");
function $e3ebf0d7bad26c5e$export$f2e26e89f653216c() {
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $ac7kz.useAnalytics)();
    const handleOnError = (0, $gwFzn.useCallback)(({ error: error, errorInfo: errorInfo })=>{
        sendAnalyticsEvent({
            eventType: 'operational',
            action: 'failed',
            actionSubject: '@atlassian/edition-awareness.edition-awareness',
            attributes: {
                error: error.message,
                errorStack: error.stack,
                errorName: error.name,
                errorComponentStack: errorInfo.componentStack,
                id: 'entrypointError'
            }
        });
    }, [
        sendAnalyticsEvent
    ]);
    return handleOnError;
}

});

parcelRegister("aKQ5r", function(module, exports) {

$parcel$export(module.exports, "EditionAwarenessButton", () => $b0c1c91ea364c712$export$57ddd9301662f8e4);
$parcel$export(module.exports, "EditionAwarenessLink", () => $b0c1c91ea364c712$export$1bf8122badfd728c);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $izVB4 = parcelRequire("izVB4");

var $yGNI1 = parcelRequire("yGNI1");

var $aH0N4 = parcelRequire("aH0N4");

var $fpGTa = parcelRequire("fpGTa");
var $6f0Oj = parcelRequire("6f0Oj");
var $2W0qg = parcelRequire("2W0qg");
var $ecnYn = parcelRequire("ecnYn");

var $i6ukv = parcelRequire("i6ukv");

var $4QwsP = parcelRequire("4QwsP");

var $2ujbw = parcelRequire("2ujbw");

var $ac7kz = parcelRequire("ac7kz");

var $a0hTw = parcelRequire("a0hTw");

var $e2ROq = parcelRequire("e2ROq");
const $b0c1c91ea364c712$var$buttonStyles = (0, $ecnYn.xcss)({
    borderWidth: 'border.width',
    font: 'font.body',
    fontWeight: 'font.weight.medium',
    borderStyle: 'solid',
    backgroundColor: 'elevation.surface',
    borderRadius: 'border.radius.100',
    paddingInline: 'space.150',
    paddingBlock: 'space.050',
    minHeight: '32px',
    color: 'color.text',
    transitionProperty: 'color, background-color',
    transitionDuration: '200ms',
    display: 'flex',
    gap: 'space.100',
    alignItems: 'center',
    textDecoration: 'none',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered',
        textDecoration: 'none',
        color: 'color.text'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.subtle.pressed',
        textDecoration: 'none'
    }
});
const $b0c1c91ea364c712$var$defaultStyles = (0, $ecnYn.xcss)({
    color: 'color.text.brand',
    borderColor: 'color.border.brand',
    ':hover': {
        color: 'color.text.brand'
    }
});
const $b0c1c91ea364c712$var$warningStyles = (0, $ecnYn.xcss)({
    borderColor: 'color.border.warning'
});
const $b0c1c91ea364c712$var$dangerStyles = (0, $ecnYn.xcss)({
    borderColor: 'color.border.danger'
});
const $b0c1c91ea364c712$var$dismissibleStyles = (0, $ecnYn.xcss)({
    color: 'color.text.discovery',
    borderColor: 'color.border.discovery',
    borderTopRightRadius: '0',
    borderBottomRightRadius: '0',
    ':hover': {
        color: 'color.text.discovery',
        backgroundColor: 'color.background.accent.purple.subtlest.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.accent.purple.subtlest.pressed',
        textDecoration: 'none'
    }
});
const $b0c1c91ea364c712$var$iconStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    // icon size cannot grow and shrink
    flexGrow: 0,
    flexShrink: 0,
    alignSelf: 'center',
    userSelect: 'none'
});
function $b0c1c91ea364c712$var$Icon({ appearance: appearance, icon: icon, color: color }) {
    if (icon === 'warning') {
        const defaultColor = appearance === 'danger' ? "var(--ds-icon-danger, #C9372C)" : "var(--ds-icon-warning, #E56910)";
        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aH0N4))), {
            label: "",
            color: color ?? defaultColor
        });
    }
    if (icon === 'credit-card') return /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($yGNI1))), {
        label: "",
        color: color ?? "var(--ds-icon-discovery, #8270DB)",
        LEGACY_size: "small"
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($izVB4))), {
        label: "",
        color: color ?? "var(--ds-icon-discovery, #8270DB)"
    });
}
const $b0c1c91ea364c712$export$57ddd9301662f8e4 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(function({ onClick: onClick, ...rest }, ref) {
    const buttonContent = (0, $a0hTw.useButtonContent)();
    if (buttonContent === null) throw new Error('The button content is null, please check the context');
    const { text: text, icon: icon, appearance: appearance = 'default', isDismissible: isDismissible, isEducationDiscount: isEducationDiscount } = buttonContent;
    const hasCustomTheme = (0, $4QwsP.useHasCustomTheme)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $ac7kz.useAnalytics)();
    const analyticsAttributes = (0, $gwFzn.useMemo)(()=>({
            type: 'button',
            icon: icon,
            appearance: appearance,
            isEducationDiscount: isEducationDiscount
        }), [
        icon,
        appearance,
        isEducationDiscount
    ]);
    const handleOnClick = (0, $gwFzn.useCallback)((e, analyticsEvent)=>{
        onClick?.(e, analyticsEvent);
        const updatedAnalyticsEvent = analyticsEvent.update((payload)=>({
                ...payload,
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'editionAwareness',
                attributes: analyticsAttributes
            }));
        sendAnalyticsEvent(updatedAnalyticsEvent);
    }, [
        onClick,
        sendAnalyticsEvent,
        analyticsAttributes
    ]);
    if (hasCustomTheme) // When there's a custom theme applied we just return a button which gets styled by the theme
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $i6ukv.Button), {
        ...rest,
        ref: ref,
        onClick: handleOnClick,
        iconBefore: ()=>/*#__PURE__*/ (0, $7UHDa.jsx)($b0c1c91ea364c712$var$Icon, {
                appearance: appearance,
                icon: icon,
                color: "currentColor"
            }),
        children: [
            text,
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2ujbw.UiViewedEvent), {
                actionSubjectId: "editionAwareness",
                actionSubject: "button",
                attributes: analyticsAttributes
            })
        ]
    });
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $2W0qg.default), {
        ...rest,
        ref: ref,
        xcss: [
            $b0c1c91ea364c712$var$buttonStyles,
            appearance === 'default' && $b0c1c91ea364c712$var$defaultStyles,
            appearance === 'warning' && $b0c1c91ea364c712$var$warningStyles,
            appearance === 'danger' && $b0c1c91ea364c712$var$dangerStyles,
            isDismissible && $b0c1c91ea364c712$var$dismissibleStyles
        ],
        onClick: handleOnClick,
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                xcss: $b0c1c91ea364c712$var$iconStyles,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)($b0c1c91ea364c712$var$Icon, {
                    appearance: appearance,
                    icon: icon
                })
            }),
            text,
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2ujbw.UiViewedEvent), {
                actionSubjectId: "editionAwareness",
                actionSubject: "button",
                attributes: analyticsAttributes
            })
        ]
    });
});
const $b0c1c91ea364c712$export$1bf8122badfd728c = /*#__PURE__*/ (0, $gwFzn.forwardRef)(function({ onClick: onClick, href: href, touchpointIntent: touchpointIntent, linkId: linkId, ...rest }, ref) {
    const buttonContent = (0, $a0hTw.useButtonContent)();
    if (buttonContent === null) throw new Error('The button content is null, please check the context');
    const { text: text, icon: icon, appearance: appearance = 'default' } = buttonContent;
    const hasCustomTheme = (0, $4QwsP.useHasCustomTheme)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $ac7kz.useAnalytics)();
    const { origin: origin, url: tracedUrl } = (0, $e2ROq.useTracedUrl)(href);
    if (!tracedUrl) throw new Error('The link url is undefined, please check the context');
    const analyticsAttributes = (0, $gwFzn.useMemo)(()=>({
            type: 'link',
            icon: icon,
            appearance: appearance,
            touchpointIntent: touchpointIntent,
            linkId: linkId,
            ...origin.toAnalyticsAttributes()
        }), [
        icon,
        appearance,
        touchpointIntent,
        linkId,
        origin
    ]);
    const handleOnClick = (0, $gwFzn.useCallback)((e, analyticsEvent)=>{
        onClick?.(e, analyticsEvent);
        const updatedAnalyticsEvent = analyticsEvent.update((payload)=>({
                ...payload,
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'editionAwareness',
                attributes: analyticsAttributes
            }));
        sendAnalyticsEvent(updatedAnalyticsEvent);
    }, [
        onClick,
        sendAnalyticsEvent,
        analyticsAttributes
    ]);
    if (hasCustomTheme) // When there's a custom theme applied we just return a button which gets styled by the theme
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $i6ukv.LinkButton), {
        ...rest,
        href: tracedUrl,
        ref: ref,
        onClick: handleOnClick,
        iconBefore: ()=>/*#__PURE__*/ (0, $7UHDa.jsx)($b0c1c91ea364c712$var$Icon, {
                appearance: appearance,
                icon: icon,
                color: "currentColor"
            }),
        children: [
            text,
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2ujbw.UiViewedEvent), {
                actionSubjectId: "editionAwareness",
                actionSubject: "button",
                attributes: analyticsAttributes
            })
        ]
    });
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $fpGTa.default), {
        ...rest,
        href: tracedUrl,
        ref: ref,
        xcss: [
            $b0c1c91ea364c712$var$buttonStyles,
            appearance === 'default' && $b0c1c91ea364c712$var$defaultStyles,
            appearance === 'warning' && $b0c1c91ea364c712$var$warningStyles,
            appearance === 'danger' && $b0c1c91ea364c712$var$dangerStyles
        ],
        onClick: handleOnClick,
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                xcss: $b0c1c91ea364c712$var$iconStyles,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)($b0c1c91ea364c712$var$Icon, {
                    appearance: appearance,
                    icon: icon
                })
            }),
            text,
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2ujbw.UiViewedEvent), {
                actionSubjectId: "editionAwareness",
                actionSubject: "button",
                attributes: analyticsAttributes
            })
        ]
    });
});

});
parcelRegister("yGNI1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7e4382cd4db66693d3c799807338c8cb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0684606e163b797c$var$_react = $0684606e163b797c$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $0684606e163b797c$var$_creditCard = $0684606e163b797c$var$_interopRequireDefault((parcelRequire("i3uiK")));

var $0684606e163b797c$var$_creditcardFilled = $0684606e163b797c$var$_interopRequireDefault((parcelRequire("aRQqo")));
function $0684606e163b797c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CreditCardIcon.
 * This component is CreditCardIcon, with `UNSAFE_fallbackIcon` set to "CreditcardFilledIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: billing in Admin, invoices in PPC, payments.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0684606e163b797c$var$CreditCardIcon = (props)=>/*#__PURE__*/ $0684606e163b797c$var$_react.default.createElement($0684606e163b797c$var$_creditCard.default, Object.assign({
        LEGACY_fallbackIcon: $0684606e163b797c$var$_creditcardFilled.default
    }, props));
$0684606e163b797c$var$CreditCardIcon.Name = 'CreditCardIconMigration';
var $0684606e163b797c$var$_default = module.exports.default = $0684606e163b797c$var$CreditCardIcon;

});

parcelRegister("2ujbw", function(module, exports) {

$parcel$export(module.exports, "UiViewedEvent", () => $026520e0abbadaad$export$d0a9edec5c713764);

var $gwFzn = parcelRequire("gwFzn");

var $ac7kz = parcelRequire("ac7kz");
function $026520e0abbadaad$export$d0a9edec5c713764({ actionSubjectId: actionSubjectId, actionSubject: actionSubject, attributes: attributes }) {
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $ac7kz.useAnalytics)();
    const hasSent = (0, $gwFzn.useRef)(false);
    (0, $gwFzn.useEffect)(()=>{
        if (hasSent.current) return;
        sendAnalyticsEvent({
            eventType: 'ui',
            action: 'viewed',
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            attributes: attributes
        });
        hasSent.current = true;
    }, [
        sendAnalyticsEvent,
        actionSubject,
        actionSubjectId,
        attributes
    ]);
    return null;
}

});

parcelRegister("a0hTw", function(module, exports) {

$parcel$export(module.exports, "useButtonContent", () => $a9f25d7cdaed579f$export$c810aba6284fa97d);

var $dBxQj = parcelRequire("dBxQj");

var $c6GJD = parcelRequire("c6GJD");

var $dh538 = parcelRequire("dh538");

var $6m14E = parcelRequire("6m14E");

var $eoBBJ = parcelRequire("eoBBJ");

var $fTb0L = parcelRequire("fTb0L");

var $kzWPO = parcelRequire("kzWPO");

var $h0D5V = parcelRequire("h0D5V");

var $6T6L4 = parcelRequire("6T6L4");

var $3nVjA = parcelRequire("3nVjA");
// TODO: `licensedUserLimit` should be fetched from the server
const $a9f25d7cdaed579f$var$PRODUCT_LIMITS_MAP = {
    'jira-product-discovery': {
        licensedUserLimit: 3,
        warningUserLimit: 2
    },
    jira: {
        licensedUserLimit: 10,
        warningUserLimit: 7
    },
    confluence: {
        licensedUserLimit: 10,
        warningUserLimit: 3
    },
    'jira-service-management': {
        licensedUserLimit: 3,
        warningUserLimit: 2
    }
};
function $a9f25d7cdaed579f$var$getFreeContent({ context: context, formatMessage: formatMessage }) {
    const { edition: edition, config: config, licensedUsers: licensedUsers, product: product } = context;
    const limits = $a9f25d7cdaed579f$var$PRODUCT_LIMITS_MAP[product];
    // Education offer has a higher priority than all the other messages
    if ((0, $kzWPO.isEligibleForEduDiscount)(context) && (0, $c6GJD.default).getExperimentValue('offer_edu_org_discount', 'cohort', 'not-enrolled') === 'variation') return {
        text: formatMessage({
            id: "@atlassian/edition-awareness.button.education-offer",
            defaultMessage: "Education discount"
        }),
        appearance: 'default',
        icon: 'gem',
        isEducationDiscount: true
    };
    if (config.warnOnUserLimit && licensedUsers) {
        if (licensedUsers >= limits.licensedUserLimit) return {
            text: formatMessage({
                id: "@atlassian/edition-awareness.button.jpd.no-creators-left",
                defaultMessage: "No {product, select, jpd {creators} jsm {agents} jira {users} confluence {users} other {users}} left"
            }, {
                product: (0, $6m14E.getProductForTranslation)(product)
            }),
            appearance: product !== 'confluence' ? 'danger' : 'warning',
            icon: 'warning'
        };
        if (licensedUsers >= limits.warningUserLimit) return {
            text: formatMessage({
                id: "@atlassian/edition-awareness.button.jpd.limited-creators-left",
                defaultMessage: "Limited {product, select, jpd {creators} jsm {agents} jira {users} confluence {users} other {users}} left"
            }, {
                product: (0, $6m14E.getProductForTranslation)(product)
            }),
            appearance: 'warning',
            icon: 'warning'
        };
    }
    let text = formatMessage({
        id: "@atlassian/edition-awareness.button.upgrade",
        defaultMessage: "Upgrade"
    });
    if (product === 'confluence' && edition === 'free' && licensedUsers && licensedUsers >= 3) // Confluence has its own variety when compared to the `userLimits` feature
    return {
        text: text,
        appearance: 'warning',
        icon: 'warning'
    };
    return {
        text: text,
        appearance: 'default',
        icon: 'gem'
    };
}
function $a9f25d7cdaed579f$var$getTrialContent({ context: context, formatMessage: formatMessage }) {
    const { product: product, edition: edition, trialDaysLeft: trialDaysLeft, trialLengthDays: trialLengthDays, isInReverseTrial: isInReverseTrial } = context;
    let appearance = 'default';
    let icon = 'gem';
    const daysLeftText = formatMessage({
        id: "@atlassian/edition-awareness.button.daysLeft",
        defaultMessage: "{trialDaysLeft, plural, one {# day} other {# days}} left"
    }, {
        trialDaysLeft: trialDaysLeft
    });
    if (product === 'jira' && (0, $6T6L4.isEligibleForStandardTrialsUserAndStorageLimitBreakers)({
        context: context
    }) && (0, $c6GJD.default).getExperimentValue('jira_edition_awareness_standard_trials', 'cohort', 'not-enrolled') === 'treatment') return {
        text: daysLeftText,
        appearance: trialDaysLeft && trialDaysLeft <= 3 ? 'danger' : 'warning',
        icon: 'warning'
    };
    if (product === 'confluence' && (0, $6T6L4.isEligibleForStandardTrialsUserAndStorageLimitBreakers)({
        context: context
    }) && (0, $c6GJD.default).getExperimentValue('connie_edition_awareness_standard_trials', 'cohort', 'not-enrolled') === 'treatment') return {
        text: daysLeftText,
        appearance: 'warning',
        icon: 'warning'
    };
    if ([
        'jira',
        'jira-service-management',
        'jira-product-discovery'
    ].includes(product)) {
        // Trial Countdown Experiment
        const trialCountdownExperimentEnabled = (0, $3nVjA.isEligibleForTrialCountdown)(context) && (0, $c6GJD.default).getExperimentValue('jira_edition_awareness_trial_countdown', 'isEnabled', false);
        // If trial is 3 days or less, swap the button to the warning state
        if (trialCountdownExperimentEnabled && !!trialDaysLeft && trialDaysLeft <= 3) {
            appearance = 'warning';
            icon = 'warning';
        }
        // If trial is still in its first half, show trial message instead of trial days left
        const isInFirstHalfOfTrial = Boolean(trialCountdownExperimentEnabled && trialDaysLeft && trialLengthDays && trialDaysLeft > Math.ceil(trialLengthDays / 2));
        if (isInFirstHalfOfTrial) {
            if (edition === 'premium') {
                if (product === 'jira' && isInReverseTrial && (0, $dh538.fg)('jira_reverse_trial_ea_updates_during_trial_gate')) {
                    if ((0, $c6GJD.default).getExperimentValue('jira_reverse_trial_ea_updates_during_trial', 'cohort', 'not-enrolled') === 'variation') return {
                        text: formatMessage({
                            id: "@atlassian/edition-awareness.button.see-plans.not-final",
                            defaultMessage: "See plans"
                        }),
                        appearance: appearance,
                        icon: icon
                    };
                }
                return {
                    text: formatMessage({
                        id: "@atlassian/edition-awareness.button.premium-trial",
                        defaultMessage: "Premium trial"
                    }),
                    appearance: appearance,
                    icon: icon
                };
            }
            if (edition === 'standard') return {
                text: formatMessage({
                    id: "@atlassian/edition-awareness.button.standard-trial",
                    defaultMessage: "Standard trial"
                }),
                appearance: appearance,
                icon: icon
            };
        }
    }
    if ((0, $fTb0L.isEligibleForConfluenceBuyReverseTrialExperiment)({
        context: context
    }) && (0, $dh538.fg)('growth_confluence_buy_reverse_trials_fg')) {
        const abCohort = (0, $c6GJD.default).getExperimentValue('growth_confluence_buy_reverse_trials_ab', 'cohort', 'not-enrolled');
        if (abCohort === 'variation') {
            if (trialDaysLeft && trialDaysLeft > 3) return {
                text: formatMessage({
                    id: "@atlassian/edition-awareness.button.see-plans.cbrt.not-final",
                    defaultMessage: "See plans"
                }),
                appearance: appearance,
                icon: icon
            };
            return {
                text: formatMessage({
                    id: "@atlassian/edition-awareness.button.see-plans.cbrt.final",
                    defaultMessage: "{trialDaysLeft, plural, =1 {# day} other {# days}} left"
                }, {
                    trialDaysLeft: trialDaysLeft
                }),
                appearance: 'warning',
                icon: 'warning'
            };
        }
    }
    return {
        text: daysLeftText,
        appearance: appearance,
        icon: icon
    };
}
function $a9f25d7cdaed579f$var$getPredunningContent({ context: context, formatMessage: formatMessage }) {
    const { edition: edition, product: product, isInReverseTrial: isInReverseTrial } = context;
    let appearance = 'default';
    let icon = 'credit-card';
    if ((0, $6T6L4.isEligibleForStandardTrialsUserAndStorageLimitBreakers)({
        context: context
    }) && (0, $c6GJD.default).getExperimentValue(product === 'jira' ? 'jira_edition_awareness_standard_trials' : 'connie_edition_awareness_standard_trials', 'cohort', 'not-enrolled') === 'treatment') {
        appearance = 'warning';
        icon = 'warning';
    }
    if (product === 'jira' && edition === 'premium' && isInReverseTrial && (0, $dh538.fg)('jira_reverse_trial_ea_updates_during_trial_gate')) {
        if ((0, $c6GJD.default).getExperimentValue('jira_reverse_trial_ea_updates_during_trial', 'cohort', 'not-enrolled') === 'variation') return {
            text: formatMessage({
                id: "@atlassian/edition-awareness.button.choose-plans.not-final",
                defaultMessage: "Choose a plan"
            }),
            appearance: 'warning',
            icon: 'warning'
        };
    }
    if ((0, $fTb0L.isEligibleForConfluenceBuyReverseTrialExperiment)({
        context: context
    }) && (0, $dh538.fg)('growth_confluence_buy_reverse_trials_fg')) {
        if ((0, $c6GJD.default).getExperimentValue('growth_confluence_buy_reverse_trials_ab', 'cohort', 'not-enrolled') === 'variation') return {
            text: formatMessage({
                id: "@atlassian/edition-awareness.button.see-plans.final",
                defaultMessage: "Choose a plan"
            }),
            appearance: 'warning',
            icon: 'warning'
        };
    }
    return {
        text: formatMessage({
            id: "@atlassian/edition-awareness.button.addPaymentDetails",
            defaultMessage: "Add payment details"
        }),
        appearance: appearance,
        icon: icon
    };
}
function $a9f25d7cdaed579f$export$c810aba6284fa97d() {
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const context = (0, $eoBBJ.useEditionAwareness)();
    const { edition: edition, isInPredunning: isInPredunning, isInTrial: isInTrial } = context;
    if (edition === 'free') return $a9f25d7cdaed579f$var$getFreeContent({
        context: context,
        formatMessage: formatMessage
    });
    if (isInTrial) return $a9f25d7cdaed579f$var$getTrialContent({
        context: context,
        formatMessage: formatMessage
    });
    if (isInPredunning) return $a9f25d7cdaed579f$var$getPredunningContent({
        context: context,
        formatMessage: formatMessage
    });
    if ((0, $h0D5V.isEligibleForStandardToPremium)(context)) return {
        text: formatMessage({
            id: "@atlassian/edition-awareness.button.upgrade.standard-to-premium",
            defaultMessage: "Upgrade"
        }),
        appearance: 'default',
        icon: 'gem',
        isDismissible: true
    };
    return null;
}

});
parcelRegister("6m14E", function(module, exports) {

$parcel$export(module.exports, "getProductForTranslation", () => $8d914a23d1ad963b$export$fd45d905638d9909);
const $8d914a23d1ad963b$var$PRODUCT_TO_TRANSLATION_KEY = {
    jira: 'jira',
    'jira-service-management': 'jsm',
    'jira-product-discovery': 'jpd',
    confluence: 'confluence'
};
function $8d914a23d1ad963b$export$fd45d905638d9909(product) {
    return $8d914a23d1ad963b$var$PRODUCT_TO_TRANSLATION_KEY[product];
}

});

parcelRegister("h0D5V", function(module, exports) {

$parcel$export(module.exports, "isEligibleForStandardToPremium", () => $d84b3820568fba5b$export$d58c0da339bf36d9);
function $d84b3820568fba5b$export$d58c0da339bf36d9({ product: product, config: { isPaidStandard: isPaidStandard }, userRoles: userRoles, trialOfferingName: trialOfferingName }) {
    return !!([
        'confluence',
        'jira',
        'jira-service-management'
    ].includes(product) && isPaidStandard && userRoles?.includes('SITE_ADMIN') && trialOfferingName === 'premium');
}

});

parcelRegister("3nVjA", function(module, exports) {

$parcel$export(module.exports, "isEligibleForTrialCountdown", () => $b8d85562e0df3326$export$947e3549c8b868b2);
function $b8d85562e0df3326$export$947e3549c8b868b2({ isInTrial: isInTrial, isInPredunning: isInPredunning, trialDaysLeft: trialDaysLeft, trialLengthDays: trialLengthDays, billingSourceSystem: billingSourceSystem }) {
    return Boolean(isInTrial && !isInPredunning && trialDaysLeft && trialLengthDays && billingSourceSystem === 'CCP');
}

});


parcelRegister("e2ROq", function(module, exports) {

$parcel$export(module.exports, "useTracedUrl", () => $6cc51f6f7cb57a0e$export$5eea7bde9861e87b);

var $gwFzn = parcelRequire("gwFzn");

var $6Co6F = parcelRequire("6Co6F");

var $eoBBJ = parcelRequire("eoBBJ");
const $6cc51f6f7cb57a0e$var$PRODUCT_TO_ORIGIN = {
    ['confluence']: 'confluence',
    ['jira']: 'jira',
    ['jira-product-discovery']: 'jira',
    ['jira-service-management']: 'jira'
};
function $6cc51f6f7cb57a0e$export$5eea7bde9861e87b(untracedUrl) {
    const { product: product } = (0, $eoBBJ.useEditionAwareness)();
    const origin = (0, $gwFzn.useMemo)(()=>new (0, $6Co6F.default)({
            product: $6cc51f6f7cb57a0e$var$PRODUCT_TO_ORIGIN[product]
        }), [
        product
    ]);
    const url = (0, $gwFzn.useMemo)(()=>untracedUrl ? origin.addToUrl(untracedUrl) : undefined, [
        untracedUrl,
        origin
    ]);
    return {
        url: url,
        origin: origin
    };
}

});



parcelRegister("04kvJ", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundary", () => $c2899783eac96921$export$e926676385687eaf);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $aPgM3 = parcelRequire("aPgM3");

var $9x4nt = parcelRequire("9x4nt");

var $4u5NT = parcelRequire("4u5NT");

var $2n68y = parcelRequire("2n68y");
const $c2899783eac96921$export$e926676385687eaf = ({ children: children, product: product, edition: edition, id: id })=>{
    const handleOnError = (0, $2n68y.useErrorAnalytics)({
        product: product,
        edition: edition,
        id: id
    });
    const ufoContext = (0, $9x4nt.useInteractionContext)();
    const onError = (0, $gwFzn.useCallback)((error)=>{
        const interaction = (0, $4u5NT.getActiveInteraction)();
        handleOnError(error);
        if (interaction && ufoContext) (0, $4u5NT.addError)(interaction?.id, error.name, ufoContext?.labelStack, 'interaction error', error.message, error.stack);
        else (0, $4u5NT.addErrorToAll)(`ErrorBoundary:${id}`, ufoContext?.labelStack || null, 'interaction error', error.message);
    }, [
        handleOnError,
        id,
        ufoContext
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aPgM3.ErrorBoundary), {
        onError: onError,
        fallback: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {}),
        children: children
    });
};

});
parcelRegister("2n68y", function(module, exports) {

$parcel$export(module.exports, "useErrorAnalytics", () => $4f61c4f554a2ab1f$export$e2d4523bbccd2343);

var $gwFzn = parcelRequire("gwFzn");

var $inPa6 = parcelRequire("inPa6");

var $ac7kz = parcelRequire("ac7kz");
/**
 * This hook is designed to be used before contexts are initialized to avoid circular dependencies.
 */ function $4f61c4f554a2ab1f$var$useOperationalFailureAnalytics({ product: product, edition: edition }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    return (0, $gwFzn.useCallback)((attributes)=>{
        const event = createAnalyticsEvent({
            eventType: 'operational',
            action: 'failed',
            actionSubject: '@atlassian/edition-awareness.edition-awareness',
            attributes: {
                ...(0, $ac7kz.defaultAttributes),
                product: product,
                currentProductEdition: edition,
                ...attributes
            }
        });
        const contextAttributes = (0, $ac7kz.getAttributesFromContexts)(event.context);
        event.update({
            attributes: {
                ...contextAttributes,
                ...event.payload.attributes
            }
        }).fire((0, $ac7kz.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        product,
        edition
    ]);
}
/**
 * These are errors which we ignore from SLO reporting to ensure we reporting on errors we can action
 */ const $4f61c4f554a2ab1f$var$nonSLOErrors = [
    /**
	 * These occur when the fetch request fails (usually this is because the users network is offline)
	 *
	 * This is usually thrown from inside of the products fetch handler
	 * e.g. jira/src/packages/platform/utils/fetch/src/utils/requests.tsx adds the handler which throws this error to every fetch request
	 */ /failed to fetch/i,
    /**
	 * These occur when the fetch request fails due to a server response (e.g. 401 due to the user needing to reauthenticate their session)
	 * e.g. jira/src/packages/platform/utils/fetch/src/utils/requests.tsx adds the handler which throws server errors after parsing the response headers
	 */ /Error server response:/i
];
function $4f61c4f554a2ab1f$var$isSLOError(error) {
    // Just checks that none of our non slo errors match the error
    return !$4f61c4f554a2ab1f$var$nonSLOErrors.some((msg)=>msg.test(error.message));
}
function $4f61c4f554a2ab1f$export$e2d4523bbccd2343({ product: product, edition: edition, id: id }) {
    const sendOperationalFailure = $4f61c4f554a2ab1f$var$useOperationalFailureAnalytics({
        product: product,
        edition: edition
    });
    return (0, $gwFzn.useCallback)((error)=>{
        sendOperationalFailure({
            error: error.message,
            errorStack: error.stack,
            errorName: error.name,
            id: id ?? 'unknownErrorId',
            isSLOError: $4f61c4f554a2ab1f$var$isSLOError(error)
        });
    }, [
        sendOperationalFailure,
        id
    ]);
}
function $4f61c4f554a2ab1f$export$45aafd752da9ba22({ product: product, edition: edition }) {
    const sendOperationalFailure = $4f61c4f554a2ab1f$var$useOperationalFailureAnalytics({
        product: product,
        edition: edition
    });
    return (0, $gwFzn.useCallback)((dataValidationError)=>{
        sendOperationalFailure({
            dataValidationError: dataValidationError,
            id: 'dataValidationError'
        });
    }, [
        sendOperationalFailure
    ]);
}

});


parcelRegister("hdlOO", function(module, exports) {

$parcel$export(module.exports, "Spotlight", () => $c6c461695454e1be$export$1033c28b5e1c2deb);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $5RBJ9 = parcelRequire("5RBJ9");
var $2Fndw = parcelRequire("2Fndw");

var $eoBBJ = parcelRequire("eoBBJ");

var $h0D5V = parcelRequire("h0D5V");
function $c6c461695454e1be$export$1033c28b5e1c2deb() {
    const context = (0, $eoBBJ.useEditionAwareness)();
    const { product: product, isSpotlightActive: isSpotlightActive, handleSetSpotlight: handleSetSpotlight } = context;
    const handleDismissSpotlight = (0, $gwFzn.useCallback)(()=>{
        handleSetSpotlight?.(false);
    }, [
        handleSetSpotlight
    ]);
    if ((0, $h0D5V.isEligibleForStandardToPremium)(context)) {
        const target = product === 'confluence' ? 'nav-profile' : 'profile-spotlight';
        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2Fndw.default), {
            children: isSpotlightActive && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5RBJ9.default), {
                actions: [
                    {
                        onClick: handleDismissSpotlight,
                        text: 'Got it'
                    }
                ],
                target: target,
                targetRadius: 3,
                dialogWidth: 275,
                targetBgColor: "var(--ds-elevation-surface-current, #FFFFFF)",
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                    id: "@atlassian/edition-awareness.spotlight.message",
                    defaultMessage: "Not ready to upgrade? Return to your profile when you're ready."
                })
            }, target)
        });
    }
    return null;
}

});


//# sourceMappingURL=EditionAwareness.65d216dc.js.map
